import { render, staticRenderFns } from "./RetencionEmision.vue?vue&type=template&id=2a9e2cbe&scoped=true&"
import script from "./RetencionEmision.vue?vue&type=script&lang=js&"
export * from "./RetencionEmision.vue?vue&type=script&lang=js&"
import style0 from "./RetencionEmision.vue?vue&type=style&index=0&id=2a9e2cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e2cbe",
  null
  
)

export default component.exports